module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_4_m.197f142390eece823216788b491d9d68.png";